/**
 * Swedish (Svenska) Translations
 * All user-facing strings in Swedish
 */

export default {
    cart: {
        empty: 'Inga produkter hittades',
        selectQuantity: 'Välj antal:',
        title: 'Varukorg',
        close: 'Stäng varukorgen',
        toCheckout: 'Till kassan',
        done: 'Klar',
        editCart: 'Ändra varukorg',
        emptyCart: 'Töm varukorgen',
        total: 'Totalt',
        goodsTotalExcl: 'Varor (exkl. frakt och rabatt)',
        giftCard: {
            to: 'Till:',
            from: 'Från:',
            message: 'Meddelande:',
            physical: 'Fysiskt kort:',
            deliveryAddress: 'Leveransadress:',
            yes: 'Ja'
        }
    },
    discount: {
        apply: 'Använd rabattkod',
        remove: 'Ta bort',
        validating: 'Validerar rabattkod...',
        invalid: 'Ogiltig rabattkod',
        error: 'Ett fel uppstod vid validering av rabattkoden. Försök igen.',
        alreadyApplied: 'Rabattkod redan applicerad',
        applied: 'Rabattkod applicerad!',
        removed: 'Rabattkod borttagen',
        placeholder: 'Ange rabattkod',
        enterCode: 'Ange en rabattkod',
        noManualDiscount: 'Ingen manuell rabattkod att ta bort'
    },
    shipping: {
        loading: 'Laddar leveransalternativ...',
        error: 'Kunde inte ladda leveransalternativ. Försök igen.',
        retry: 'Försök igen',
        free: 'Gratis',
        noOptions: 'Inga leveransalternativ tillgängliga för tillfället.',
        contactSupport: 'Kontakta kundservice för hjälp.',
        selectRequired: 'Vänligen välj ett leveransalternativ',
        methods: {
            PickUpStore: 'Hämta i butik',
            Home: 'Hemleverans',
            BoxReg: 'Box (registrerad)',
            BoxUnreg: 'Box (oregistrerad)',
            PickUpPoint: 'Hämtställe',
            Own: 'Egen leverans',
            Postal: 'Postombud',
            DHLPackstation: 'DHL Paketstation',
            Digital: 'Digital leverans'
        }
    },
    checkout: {
        emptyCart: 'Inga produkter i varukorgen',
        fillRequired: 'Vänligen fyll i alla obligatoriska fält och godkänn användarvillkoren.',
        paymentError: 'Betalningen misslyckades. Försök igen.',
        paymentCancelled: 'Betalningen avbröts eller misslyckades.',
        processing: 'Behandlar...',
        placeOrder: 'Lägg beställning',
        error: 'Ett fel uppstod vid checkout. Försök igen.',
        noItems: 'Inga produkter i varukorgen',
        noCheckoutUrl: 'Ingen checkout-URL mottogs från betalningsleverantören',
        initiateFailed: 'Kunde inte initiera betalning. Försök igen.'
    },
    giftCardPayment: {
        apply: 'Använd presentkort',
        remove: 'Ta bort',
        validating: 'Validerar presentkort...',
        invalid: 'Presentkortet kunde inte användas. Kontrollera kortnummer och PIN-kod.',
        error: 'Ett fel uppstod vid validering av presentkortet. Försök igen.',
        enterCard: 'Ange kortnummer och PIN-kod',
        removed: 'Presentkort borttaget',
        balanceLabel: 'saldo',
        fullCoverageInfo: 'Hela ordern betalas med presentkortet – ingen kortbetalning behövs.',
        partialNotSupported: 'Presentkortet täcker inte hela ordern och kan inte kombineras med detta betalsätt. Ta bort presentkortet för att fortsätta.'
    },
    common: {
        subtotal: 'Delsumma',
        shipping: 'Frakt',
        discount: 'Rabatt',
        total: 'Totalt',
        yes: 'Ja',
        no: 'Nej',
        loading: 'Laddar...',
        error: 'Ett fel uppstod',
        tryAgain: 'Försök igen'
    },
    giftCard: {
        defaultName: 'Presentkort',
        addedToCart: 'Tillagt i varukorg!',
        customAmount: {
            title: 'Ange belopp',
            required: 'obligatoriskt',
            quickSelect: 'Populära val:',
            inputLabel: 'Ange belopp',
            inputPlaceholder: 't.ex. 1500',
            minMaxHint: 'Min: {min} kr | Max: {max} kr',
            selectedLabel: 'Valt belopp:',
            noneSelected: '-',
            currencySuffix: 'kr',
            validation: {
                required: 'Vänligen ange ett belopp',
                invalid: 'Ogiltigt belopp',
                tooLow: 'Minimibelopp är {min} kr',
                tooHigh: 'Maximibelopp är {max} kr',
                mustBeNumber: 'Beloppet måste vara ett nummer',
                mustBeInteger: 'Beloppet måste vara ett heltal'
            }
        },
        validation: {
            recipientNameRequired: 'Mottagarens namn är obligatoriskt',
            nameTooShort: 'Namnet måste vara minst 2 tecken',
            emailRequired: 'E-postadress är obligatorisk för digitala presentkort',
            emailInvalid: 'Ange en giltig e-postadress',
            senderNameRequired: 'Avsändarens namn är obligatoriskt',
            deliveryNameRequired: 'Förnamn är obligatoriskt för fysiska kort',
            deliveryLastnameRequired: 'Efternamn är obligatoriskt för fysiska kort',
            deliveryAddressRequired: 'Adress är obligatorisk för fysiska kort',
            addressTooShort: 'Adressen måste vara minst 5 tecken',
            deliveryZipRequired: 'Postnummer är obligatoriskt för fysiska kort',
            zipInvalid: 'Postnummer måste vara 5 siffror',
            deliveryCityRequired: 'Ort är obligatorisk för fysiska kort',
            cityTooShort: 'Orten måste vara minst 2 tecken'
        },
        errors: {
            noProductId: 'Kunde inte fastställa produkt-ID',
            addToCartFailed: 'Ett fel uppstod när presentkortet skulle läggas till i varukorgen'
        }
    }
};
